import React from 'react';
import { Heart, Instagram, Facebook, Twitter, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-foreground text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-serif font-semibold mb-4">
              Waisted Momma
            </h3>
            <p className="text-white/70 font-sans text-sm leading-relaxed mb-6 max-w-md">
              Empowering women through premium shapewear and waist trainers. Confidence starts with support — inside and out.
            </p>
            <div className="flex gap-4">
              <a href="https://instagram.com/WaistedMomma" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://instagram.com/WaistedMomma" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://instagram.com/WaistedMomma" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors" aria-label="Twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="mailto:hello@waistedmomma.com" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors" aria-label="Email">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Shop Column */}
          <div>
            <h4 className="font-sans font-semibold text-sm tracking-wider mb-4">SHOP</h4>
            <ul className="space-y-3 text-sm font-sans text-white/70">
              <li><a href="#" className="hover:text-white transition-colors">All Products</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Waist Trainers</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Shapewear</a></li>
              <li><a href="#" className="hover:text-white transition-colors">New Arrivals</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Best Sellers</a></li>
            </ul>
          </div>

          {/* Support Column */}
          <div>
            <h4 className="font-sans font-semibold text-sm tracking-wider mb-4">SUPPORT</h4>
            <ul className="space-y-3 text-sm font-sans text-white/70">
              <li><a href="#" className="hover:text-white transition-colors">Contact Us</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Size Guide</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Shipping Info</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Returns & Exchanges</a></li>
              <li><a href="#faq" className="hover:text-white transition-colors">FAQ</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm font-sans text-white/60">
            © 2025 Waisted Momma. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm font-sans text-white/60">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
          </div>
        </div>

        {/* Love note */}
        <div className="mt-8 text-center">
          <p className="text-sm font-sans text-white/50 flex items-center justify-center gap-2">
            Made with <Heart className="w-4 h-4 fill-accent-gold text-accent-gold" /> for empowered women everywhere
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
